export default function getRandomElementOfEnum<E>(e: any): E {
	const keys = Object.keys(e);
	const index = Math.floor(Math.random() * keys.length);
	const k = keys[index];

	if (typeof e[k] === 'number') {
		return e[k];
	}

	return parseInt(k, 10) as any;
}
